<form #checkout="ngForm">
  <div class="col-12" style="padding-top:0px;">
    @if (isFirmtime) {
      <div class="col-12">
        <div>
          To book your firm-time quote with an ISA Certified Arborist, please provide your credit/debit card information below to be <b>charged immediately</b>.
          By clicking the button below you authorize Russell Tree Experts to store your card through Stripe, a secure merchant service provider.
        </div>
      </div>
    }
    @if (!isPayInAdvance && !isCustomerProfile && !isFirmtime) {
      <div class="col-12">
        <div style="text-align: center;">
          To reserve your services on our production schedule a major credit card is required.
          <br/>
          <span class="bold">Your card will not be charged at this time.</span>
        </div>
      </div>
    }
    @if (isPayInAdvance && !isCustomerProfile) {
      <div class="col-12" style="text-align: center;">
        <span>To reserve your space on our production schedule please provide your credit/debit card information below to be
          <b>charged immediately</b> for the full price of the quote. By clicking the “Pay” below I authorize Russell Tree Experts to store my card through Stripe,
        a secure merchant service provider.</span>
      </div>
    }
    <p-card>
      <p-header class="card-header">
        Credit/Debit Card Info
      </p-header>
      <div class="card-body grayBG">
        <!-- Credit Card Fields -->
        <div class="row">
          <div class="col-12 col-lg-8">
            <h6>Card Number</h6>
            <div id="cardNumber1" pInputText #cardNumber [style.display]="renderSavedCard == false ? 'block' : 'none'"></div>
            @if (renderSavedCard) {
              <input fluid pInputText class="form-control inputTextBox" name="last4" [value]="'xxxx-xxxx-xxxx-' + stripeBilling.cCLast4" disabled/>
            }
            @if ((renderSavedCard || updateWithNewCard)) {
              <div style="text-align: left;">
                @if (renderSavedCard) {
                  <a href="#" (click)="addNewCard($event); clearErrors();" style="cursor:pointer">Enter a different card to use</a>
                }
                @if (!renderSavedCard) {
                  <a href="#" (click)="cancelAddNewCard($event); clearErrors();" style="cursor:pointer">Cancel</a>
                }
              </div>
            }
          </div>
          <div class="col-6 col-lg-2">
            <h6>Expiration</h6>
            <div id="cardExpiry1" pInputText #cardExpiry [style.display]="renderSavedCard == false ? 'block' : 'none'"></div>
            @if (renderSavedCard) {
              <input fluid id="expiration" [textMask]="{mask: ccExpirationMask}" pInputText class="form-control inputTextBox" name="exp" [(ngModel)]="stripeBilling.expiration" placeholder="MM/YY" (ngModelChange)="clearErrors();;removeExpirationError();" disabled/>
            }
            <!---->
          </div>
          <div class="col-6 col-lg-2">
            <h6>CVC</h6>
            <div id="cardCvc1" pInputText #cardCvc [style.display]="renderSavedCard == false ? 'block' : 'none'"></div>
            @if (renderSavedCard) {
              <input fluid pInputText class="form-control inputTextBox" name="cvc" value="xxx" disabled/>
            }
          </div>
        </div>
        <!-- Billing Address Fields -->
        @if (isCustomerProfile) {
          <div class="col-12">
            <p-checkbox binary="true" name="sameaddress" [(ngModel)]="sameAddressAsContact" (click)="onToggleSameAddressCheckbox()"></p-checkbox>
            <span style="margin-left:8px;">Same as Billing Address</span>
          </div>
        }
        <div class="row">
          <div class="col-12 col-sm-8">
            <h6>Billing Address</h6>
            <input fluid id="address" pInputText [(ngModel)]="stripeBilling.address" name="address" (ngModelChange)="clearErrors(); onAddresChange()" [required]="true" placeholder="Address"/>
          </div>
          <div class="col-12 col-sm-4">
            <h6>Zip</h6>
            <input fluid id="zip" pInputText [(ngModel)]="stripeBilling.zip" name="address_zip" (ngModelChange)="clearErrors();" (change)="removeZipError()" [required]="true" type="text" pattern="[0-9]*" placeholder="ZIP"/>
          </div>
          <div class="col-12" style="text-align: right;">
            <img src="../../../assets/Stripe.png" height="25px">
          </div>
        </div>
      </div>

      <!-- Manual cash/check Option-->
      @if (!isPayInAdvance && paymentTypeEnabled(PaymentType.Manual) && !isQuote) {
        <div class="col-12">
          @if (customer) {
            <p-checkbox binary="true" [(ngModel)]="customer.manualPayment" name="manualPay"></p-checkbox>
          }
          <span style="margin-left:8px;">Pay by Cash or Check@if (isCustomerProfile) {
            <span>*</span>
          }</span>
          @if (isCustomerProfile) {
            <div>
              <span style="font-size:12px">*(Please note that a credit/debit card is required to reserve your space on our production schedule even if you intend to pay by cash or check.)</span>
            </div>
          }
        </div>
      }
      @if (!isPayInAdvance && !isCustomerProfile && !isFirmtime) {
        <div class="col-12">
          By clicking the “Save” button below you authorize Russell Tree Experts to store your card through Stripe, a secure merchant service provider.
          @if (!isQuote) {
            <span>Customer acknowledges the payment(s) will be processed the next business day following the completion of each service if “Pay by Cash or Check” is not selected.</span>
          }
        </div>
      }
    </p-card>
  </div>
</form>